import { render, staticRenderFns } from "./orderPage.vue?vue&type=template&id=4e1835fb&scoped=true"
import script from "./orderPage.vue?vue&type=script&lang=js"
export * from "./orderPage.vue?vue&type=script&lang=js"
import style0 from "./orderPage.vue?vue&type=style&index=0&id=4e1835fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1835fb",
  null
  
)

export default component.exports